module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand3-61a147dfc4b355cb8ecab1c0d7a6bd4d.jpg";